import { Box, colors, spacing, Spinner, Typography } from "@procore/core-react";

interface LoadingStateProps {
    message: string;
}

export function LoadingState({ message }: LoadingStateProps) {
    return (
        <Box
            flex={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            gap="md"
        >
            <Spinner />
            <Typography
                style={{
                    fontSize: "1.1em",
                    fontWeight: "600",
                    color: colors.gray15,
                    marginTop: spacing.sm,
                }}
            >
                {message}
            </Typography>
        </Box>
    );
}
